import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '@shared/module/shared.module';
import { GetUserDataPipe } from '@shared/components/User-Activity-Info/pipes/get-user-data/get-user-data.pipe';
import { UserActivityInfoComponent } from '@shared/components/User-Activity-Info/user-activity-info/user-activity-info.component';
import { IPostModel } from '../../models/post.model';
import { htmlUrls } from '@shared/utils/router-paths';
import { EImageType } from '@shared/pipes/image.pipe';

@Component({
    selector: 'app-post-suggeste-item',
    imports: [
        SharedModule,
        GetUserDataPipe,
        UserActivityInfoComponent,
    ],
    templateUrl: './post-suggeste-item.component.html',
    styleUrls: ['./post-suggeste-item.component.scss']
})
export class PostSuggesteItemComponent implements OnInit {
  @Input() Post!: IPostModel;
  routes = htmlUrls;
  imageType = EImageType
  constructor() { }

  ngOnInit(): void {
  }

}
